<style scoped lang="less">
@import "./style.less";
</style>
<script>


export default {
  name: "statics",
  props: {
    data: { type:Object, default: () => null }
  },
  methods:{
    comPercent(newData,total){
      if(!newData || !total) return '--%'
      return ((newData / total) * 100).toFixed(2) + '%'
    }
  },
  computed:{
    statics:(_this = this) => ({
      percent: _this.comPercent(_this.$props.data?.new?.commodityCount,_this.$props.data?.total?.commodityCount),
      count: _this.$retainWan(_this.$props.data?.new?.commodityCount,false,2,'--'),
      salesVolume: _this.$retainWan(_this.$props.data?.new?.salesVolume,false,2,'--'),
      sales: '¥' + _this.$retainWan(_this.$props.data?.new?.sales,false,2,'--'),
    }),
    hiddenModule: (_this = this) =>
      !_this.$props.data?.new?.sales &&
      !_this.$props.data?.new?.salesVolume &&
      !_this.$props.data?.new?.commodityCount
  },
}
</script>
<template>
  <div class="statics" v-if="!hiddenModule">
    <div class="statics_head">
      <div class="statics_head_dot" />
      <div class="statics_head_title">新品数量占比</div>
      <div class="statics_head_value">{{statics.percent}}</div>
    </div>
    <div class="statics_row">
      <div class="statics_row_label">新品商品数</div>
      <div class="statics_row_value">{{statics.count}}</div>
    </div>
    <div class="statics_row">
      <div class="statics_row_label">新品销量</div>
      <div class="statics_row_value">{{statics.salesVolume}}</div>
    </div>
    <div class="statics_row">
      <div class="statics_row_label">新品销售额</div>
      <div class="statics_row_value">{{statics.sales}}</div>
    </div>
  </div>
</template>

